const anchors = document.querySelectorAll(".content a[href*='#']");
anchors.forEach(anchor => {
	anchor.addEventListener("click", event => {
		event.preventDefault();
		let masthead_height = document.querySelector(".masthead").offsetHeight;
		let target_selector = event.target.getAttribute("href");
		let target_top = document.querySelector(target_selector).offsetTop;
		window.scrollTo({
			top: target_top - masthead_height,
			behavior: 'smooth'
		});
	});
})
